import { render, staticRenderFns } from "./formModal.vue?vue&type=template&id=afd6f8ec&scoped=true&"
import script from "./formModal.vue?vue&type=script&lang=js&"
export * from "./formModal.vue?vue&type=script&lang=js&"
import style0 from "./formModal.vue?vue&type=style&index=0&id=afd6f8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd6f8ec",
  null
  
)

export default component.exports